export {default as ZoneBannerVideo} from './zone.mp4'